module.exports = __webpack_public_path__ + "img/promote_thumbnail-600x450.9e6cd44f.jpg";